export const cardDescriptionPrefix = '#card-description-popup-'
